module.exports = __webpack_public_path__ + "static/img/feiliaozhan.2ab76be1.png";